import {api} from '../services/api';

const loginUrl = `auth/login/admin/email`;

export const loginApi = (params) => {
  return api.post(loginUrl, params);
};
